import { createSelector } from 'reselect'

import { getOfferingActualsValueTypeDefault } from 'partner360/helpers/getOfferingActualsValueTypeDefault'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { getCockpitMetricOffering } from '../../lib/getCockpitMetricOffering'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

/** The cockpit's own metric. The plan export uses `selectCockpitDefaultExportPDFMetric`. */
export const selectCockpitDefaultMetric = createSelector([selectFinancialCockpitState], (state) => {
  const defaultMetric = getOfferingActualsValueTypeDefault(getCockpitMetricOffering(state))

  return (
    Object.values(ActualsValueTypes).find(
      (type) => type !== ActualsValueTypes.None && type === defaultMetric
    ) ?? ActualsValueTypes.TNet
  )
})
